export const TIMEZONE_OPERACIONAL = 'America/Sao_Paulo';

export function diaOperacional(agora: Date): string {
  const partes = new Intl.DateTimeFormat('en-CA', { timeZone: TIMEZONE_OPERACIONAL, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(agora);
  const valor = (tipo: string) => partes.find(p => p.type === tipo)?.value ?? '';
  return valor('year') + '-' + valor('month') + '-' + valor('day');
}

export function saudacaoOperacional(agora: Date): string {
  const hora = Number(new Intl.DateTimeFormat('pt-BR', { timeZone: TIMEZONE_OPERACIONAL, hour: 'numeric', hourCycle: 'h23' }).format(agora));
  return hora < 5 || hora >= 18 ? 'Boa noite' : hora < 12 ? 'Bom dia' : 'Boa tarde';
}

export function rotuloDia(dia: string): string {
  const partes = dia.split('-');
  return partes.length === 3 ? partes.reverse().join('/') : dia;
}
